import { createSlice } from '@reduxjs/toolkit';
import { fetchAdminClientClientList } from './features';

export const adminClientClientList = createSlice({
  name: 'adminClientClientList',
  initialState: {
    clients: null,
    isLoadingClients: false,
    isError: false,
  },  reducers: {
    removeClient: (state, action) => {
      state.clients = state.clients.filter(
        (item) => item.id !== action.payload
      );
    },
    removeAdminClientClient: (state, action) => {
      state.clients = state.clients.filter(
        (item) => item.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminClientClientList.fulfilled, (state, { payload }) => {
        state.clients = Array.isArray(payload) ? payload : [];
        state.isLoadingClients = false;
        state.isError = false;
      })      .addCase(fetchAdminClientClientList.pending, (state) => {
        state.isLoadingClients = true;
        state.isError = false;
      })
      .addCase(fetchAdminClientClientList.rejected, (state) => {
        state.isLoadingClients = false;
        state.isError = true;
        if (state.clients === null) {
          state.clients = [];
        }
      });  },
});

export default adminClientClientList.reducer;

export const { removeClient, removeAdminClientClient } = adminClientClientList.actions;

export const adminClientClientListSelector = (state) =>
  state.adminClientClientList;
